import { object, string } from 'yup';

// @TODO more validation
export default object().shape({
  name: string().required('Name is required'),
  zip: string().required('Zip code is required'),
  year: string().required('Expiration date is required'),
  month: string().required('Expiration date is required'),
});
